import { useCallback, useSyncExternalStore } from 'react';
import {
  getShowAlternatives,
  subscribeShowAlternatives,
  toggleShowAlternatives,
} from 'src/utils/showAlternativesPreference';

export function useShowAlternatives(language: string) {
  const getSnapshot = useCallback(() => getShowAlternatives(language), [language]);

  const showAlternatives = useSyncExternalStore(
    subscribeShowAlternatives,
    getSnapshot,
    /* istanbul ignore next: SSR snapshot */
    () => false,
  );

  const toggle = useCallback(() => toggleShowAlternatives(language), [language]);

  return { showAlternatives, toggleShowAlternatives: toggle };
}

export default useShowAlternatives;
